import AppService from '../../services/app.service';
import EventModel from '../event/event-model';
import ProductModel from '../product/product-model';
import ScheduleModel from '../schedule/schedule-model';
import TransactionModel from '../transaction/transaction-model';

export default class TransactiondetailModel {
    id: number;
    name: string;
    description: string;
    status: string;
    startdate: any;
    startdateFmt: string;
    price: number;
    qty: number;
    value: number;
    product: any;
    productCaption: string;
    productQty: number;
    productQtymin: number;
    productQtymax: number;
    productProducttypeType: any;
    productProductLength: number;
    productEvent: any;
    productSchedule: any;
    transaction: any;
    transactionCaption: string;
    transactionStatus: string;
    transactionCustomerCaption: string;
    transactiontype: any;
    transactiontypePricetype: string;
    event: any;
    eventCaption: string;
    schedule: any;
    scheduleCaption: string;
    scheduleDisableday: any;
    rating: number;
    comment: string;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.startdate = datarow.startdate;
        this.startdateFmt = AppService.dateFormat(datarow.startdate, 'y-m-d h:n');
        this.price = datarow.price;
        this.qty = datarow.qty || 1;
        this.value = datarow.value;
        let product = datarow.product?.data? new ProductModel(datarow.product?.data) : datarow.product;
        this.product = product?.id;
        this.productCaption = product?.name;
        this.productQty =  product?.qty || 0;
        this.productQtymin =  product?.qtymin || 0;
        this.productQtymax =  product?.qtymax || 0;
        this.productProducttypeType = product?.producttypeType;
        this.productProductLength =  product?.product?.data?.length;
        this.productEvent =  product?.event;
        this.productSchedule =  product?.schedule;
        let transaction = datarow.transaction?.data? new TransactionModel(datarow.transaction?.data) : datarow.transaction;
        this.transaction = transaction?.id;
        this.transactionCaption = transaction?.name;
        this.transactionStatus = transaction?.status;
        this.transactionCustomerCaption = transaction?.customerCaption;
        this.transactiontype = transaction?.transactiontype;
        this.transactiontypePricetype = transaction?.transactiontypePricetype || 'pricebase';
        let event = datarow.event?.data? new EventModel(datarow.event?.data) : datarow.event;
        this.event = event?.id;
        this.eventCaption = event?.name;
        let schedule = datarow.schedule?.data? new ScheduleModel(datarow.schedule?.data) : datarow.schedule;
        this.schedule = schedule?.id || datarow.schedule;
        this.scheduleCaption = schedule?.name;
        this.scheduleDisableday = schedule?.disableDay;
        this.rating = datarow.rating;
        this.comment = datarow.comment;
    } 

    public static endPoint: string = 'transaction-details';
    public static endPointFilterList = (productId?: number, transactionId?: number, transactionStatus?: string) => {       

        return (
         '?populate[product][sort]=id' +
         '&populate[product][populate]=product' +
         '&populate[product][populate]=producttype' +
         '&populate[product][populate]=event' +
         '&populate[product][populate]=schedule' +
         '&populate[event][sort]=id' +
         '&populate[schedule][sort]=id' +
         '&populate[transaction][sort]=id' +
         '&populate[transaction][populate]=customer' +
         (productId? '&filters[product][id]=' + productId : '') +
         (transactionId? '&filters[transaction]=' + transactionId : '') +
         (transactionStatus? '&filters[transaction][status]=' + transactionStatus : '')
        );

    }
    public static endPointFilter2: string = '?populate[product][sort]=id' +
                                            '&populate[product][populate]=product' +
                                            '&populate[product][populate]=producttype' +
                                            '&populate[product][populate]=event' +
                                            '&populate[product][populate]=schedule' +
                                            '&populate[event][sort]=id' +
                                            '&populate[schedule][sort]=id' +
                                            '&populate[transaction][sort]=id' +
                                            '&populate[transaction][populate]=transactiontype' +
                                            '&filters[id]=';

    public static url: string = '/transactiondetail';

    public static caption: string = 'Order Detail';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        price: 0,
        qty: 1,
        value: 0,
        startdate: AppService.dateCurrent(),
        startdateFmt: '',
        product: null,
        productCaption: '',
        productQty: 0,
        productQtymin: 0,
        productQtymax: 0,
        productProducttypeType: null,
        productProductLength: 0,
        productEvent: null,
        productSchedule: [],
        transaction: null,
        transactionCaption: '',
        transactionStatus: '',
        transactionCustomerCaption: '',
        transactiontype: null,
        transactiontypePricetype: 'pricebase',  
        event: null,
        eventCaption: '',
        schedule: null,
        scheduleCaption: '',
        scheduleDisableday: [],
        rating: 0,
        comment: '',
        }
    }
    
    public static validations = [
        { name: 'qty', minValue: 1 },
    ]

    public static columns = [
        { name: 'productCaption', caption: 'Product' },
        { name: 'price', caption: 'Price', type: 'money' },
        { name: 'qty', caption: 'Qty', type: 'number' },  
        { name: 'value', caption: 'Total', type: 'money' },
              
    ]

    public static columnPicklist = [
        { name: 'productCaption', caption: 'Product' },
        { name: 'price', caption: 'Price', type: 'money' },
        { name: 'qty', caption: 'Qty', type: 'number' },  
        { name: 'value', caption: 'Total', type: 'money' },
    ]

    public static columnPicklistCardReview = [
        { name: 'rating', type: 'rating' },
        { name: 'transactionCustomerCaption', type: 'caption', size: 'small', color: 'primary.main'},
        { name: 'comment' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}